import { combineReducers } from 'redux';

import DashboardReducer from './dashboardReducer';
import DocumentoFiscalReducer from './documentoFiscalReducer';
import EmpresaReducer from './empresaReducer';
import EnumeradorReducer from './enumeradorReducer';
import HistoricoConsulta from './historicoConsultaReducer';
import ManifestoReducer from './manifestoReducer';
import NotificacaoReducer from './notificacaoReducer';
import RotaReducer from './rotaReducer';
import UsuarioReducer from './usuarioReducer';
import filaChavesReducer from './filaChavesReducer';

const rootReducer = combineReducers({
  dashboard: DashboardReducer,
  documentoFiscal: DocumentoFiscalReducer,
  empresa: EmpresaReducer,
  enumerador: EnumeradorReducer,
  historicoConsulta: HistoricoConsulta,
  manifesto: ManifestoReducer,
  notificacao: NotificacaoReducer,
  filaChaves: filaChavesReducer,
  rota: RotaReducer,
  usuario: UsuarioReducer,
});

export default rootReducer;
